import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Feeder11Service } from 'shared-lib';
import { F11Crud, F11CrudCreate } from '../../../models/feeder11.model';
import { SubstationCrud } from 'shared-lib';
import { F33Crud } from '../../../models/f33.model';
import { SubstationService } from 'shared-lib';
import { RegionService } from 'shared-lib';
import { Region } from 'shared-lib';
import { TransmissionStation } from 'shared-lib';
import { TransmissionStationService } from 'shared-lib';
import { UtilitySharedService } from '../../../shared/_services/utility-shared.service';

@Component({
  selector: 'app-crud-f11',
  templateUrl: './crud-f11.component.html',
  styleUrl: './crud-f11.component.scss',
  standalone: false
})
export class CrudF11Component implements OnInit {
  @ViewChild('closeAddModal') closeAddModal: ElementRef;

  count: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  utilityId: number = 1;
  searchText: string = "";

  selectedF11: F11Crud = new F11Crud();
  isEditMode: boolean = false;

  feeders11: F11Crud[] = [];

  // For edit/add
  updatedName: string = '';
  updatedNumber: string = '';
  updatedTsId: number | null = null;
  updatedSsId: number | null = null;
  updatedF33Id: number | null = null;
  updatedRegionId: number | null | undefined = null;
  updatedNameplateRating: string | null = null;

  // Asset lists
  transmissionStations: TransmissionStation[] = [];
  substations: SubstationCrud[] = [];
  feeders33: F33Crud[] = [];
  regions: Region[] = [];

  // To save
  f11ToSave: F11CrudCreate = new F11CrudCreate();

  @ViewChild('filterTemplate', { static: true })
  filterTemplate!: TemplateRef<any>;

  @Output() filterTemplateReady = new EventEmitter<TemplateRef<any>>();

  @Input() set refreshTrigger(_: number) {
    this.filterTemplateReady.emit(this.filterTemplate);
  }

  isDirectToTs: boolean | null = null;

  nameplateRatingOptions = [
    '50KVA',
    '100KVA',
    '200KVA',
    '300KVA',
    '500KVA',
    '750KVA',
    '1000KVA',
    '2000KVA',
  ];

  constructor(
    private feeder11Service: Feeder11Service,
    private ssService: SubstationService,
    private regionService: RegionService,
    private toastr: ToastrService,
    private tsService: TransmissionStationService,
    private utilitySharedService: UtilitySharedService
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.filterTemplateReady.emit(this.filterTemplate);
    this.getAllTss();
    this.getAllSs();
    this.getAllRegions();
    this.reloadTable(1);
  }

  openAddModal() {
    this.isEditMode = false;
    this.isDirectToTs = null;

    this.selectedF11 = new F11Crud();
    this.updatedName = '';
    this.updatedNumber = '';
    this.updatedTsId = null;
    this.updatedSsId = null;
    this.updatedF33Id = null;
    this.updatedRegionId = null;
    this.updatedNameplateRating = null;
    this.feeders33 = [];
  }

  selectF33(feederId: number){
    if(feederId === 0 && this.updatedF33Id !== 0) {
      return;
    }
    this.updatedF33Id = feederId;
  }

  selectRegion(regionId: number){
    if(regionId === 0 && this.updatedRegionId !== 0) {
      return;
    }
    this.updatedRegionId = regionId;
  }

  selectSs(ssId: number){
    if(ssId === 0 && this.updatedSsId !== 0) {
      return;
    }
    this.updatedSsId = ssId;
    this.onSsChange();
  }

  openEditModal() {
    this.isEditMode = true;
    this.fillInputFields();
    this.onSsChange();
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.reloadTable(newPage);
  }

  private getAllFeeders(dataIn: any) {
    this.feeder11Service.getAll(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.feeders11 = responseData.data.data;
          this.count = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  selectF11(item: F11Crud) {
    if (item.feeder33Id === 0 && this.updatedF33Id !== 0) {
      return;
    }
    this.selectedF11 = item;
    if(this.selectedF11.transmissionStationId != null) {
      this.isDirectToTs = true;
    }
    else {
      this.isDirectToTs = false;
    }
    this.openEditModal();
  }

  onDeleteF11(item: F11Crud){
    this.selectedF11 = item;
    this.isEditMode = false;
  }

  private fillInputFields() {
    this.updatedName = this.selectedF11.name;
    this.updatedNumber = this.selectedF11.number;
    this.updatedTsId = this.selectedF11.transmissionStationId ?? null;
    this.updatedSsId = this.selectedF11.substationId ?? null;
    this.updatedF33Id = this.selectedF11.feeder33?.id ?? null;
    this.updatedRegionId = this.selectedF11.region?.id;
    this.updatedNameplateRating = this.selectedF11.nameplateRating;
  }

  onDirectToTsChange() {
    this.updatedTsId = null;
    this.updatedSsId = null;
    this.updatedF33Id = null;
  }
  
  deleteF11() {
    this.feeder11Service.delete(this.selectedF11.id).subscribe({
      next: (response: any) => {
        if (response.body.status === 200 || response.body.status === 'OK') {
          this.onPageChange(1);
          this.toastr.success(response.body.message);
        } else {
          this.toastr.error(response.body.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getFilterObject() {
    const obj = {
      searchValue: this.searchText
    };
    return obj;
  }

  reloadTable(page: number | null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId
    };
    this.getAllFeeders(obj);
  }

  onSsChange() {
    if (this.updatedSsId) {
      this.getF33s(this.updatedSsId);
    } else {
      this.feeders33 = [];
      this.updatedF33Id = null;
    }
  }

  getF33s(ssid: number) {
    this.ssService.getF33sBySSId(ssid).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.feeders33 = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getAllRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data.map((region: Region) => ({
            ...region,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.regions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getAllTss() {
    this.tsService.getAllForSelect(this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.transmissionStations = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getAllSs() {
    this.ssService.getAllForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.substations = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  download() {
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId,
    };

    this.feeder11Service.download(dataIn).subscribe({
      next: (response: any) => {
        window.location.href = response.data;
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
        this.reloadTable(1);
      }
    });
  }

  private mapFeeder() {
    this.f11ToSave.id = this.isEditMode ? this.selectedF11.id : 0;
    this.f11ToSave.utilityId = this.utilityId;
    this.f11ToSave.name = this.updatedName;
    this.f11ToSave.number = this.updatedNumber;
    this.f11ToSave.feeder33Id = this.updatedF33Id !== null ? +this.updatedF33Id : null;
    this.f11ToSave.regionId = (this.updatedRegionId !== null && this.updatedRegionId !== undefined) ? +this.updatedRegionId : 0;
    this.f11ToSave.substationId = this.updatedSsId !== null ? +this.updatedSsId : null;
    this.f11ToSave.transmissionStationId = this.updatedTsId !== null ? +this.updatedTsId : null;
    this.f11ToSave.nameplateRating = this.updatedNameplateRating || '';
  }

  save() {
    this.mapFeeder();
    if(this.isDirectToTs == null) {
      this.toastr.warning("Please select if it is connected directly to TS!");
      return;
    }
    if (this.f11ToSave.name === '') {
      this.toastr.warning("Name can't be empty!");
    } else if (this.f11ToSave.number === '') {
      this.toastr.warning("Number can't be empty!");
    } else if (this.f11ToSave.transmissionStationId == null && this.isDirectToTs == true) {
      this.toastr.warning("Please select a Transmission Station!");
    } else if (this.f11ToSave.substationId == null && this.isDirectToTs == false) {
      this.toastr.warning("Please select an Injection Substation!");
    } else if (this.f11ToSave.feeder33Id == null && this.isDirectToTs == false) {
      this.toastr.warning("Please select a Main Feeder!");
    } else if (this.f11ToSave.regionId === 0) {
      this.toastr.warning("Please select a Region!");
    } else if (this.f11ToSave.nameplateRating === '') {
      this.toastr.warning("Please select a Nameplate Rating!");
    } else {
      this.feeder11Service.save(this.f11ToSave).subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.toastr.success(responseData?.message);
            setTimeout(() => {
              this.closeAddModal?.nativeElement?.click();
              this.reloadTable(1);
            }, 500);
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occurred');
        },
      });
    }
  }

  onSearch() {
    this.reloadTable(1);
  }
}